import { IFeedWikifolioNewsResponse } from "src/api/client/feed/feed-wikifolio-news.api.types";
import { API_FEED_V3_NEWS_WIKIFOLIO } from "src/constants/urls";
import { IQueryOptions } from "src/lib/tanstack-query/hooks/use-query";
import { useQuery } from "src/lib/tanstack-query/hooks/use-query";
import { feedKeys } from "./feed.query-keys";

export const useFeedWikifolioNewsQuery = (wikifolioId: string, options: IQueryOptions<IFeedWikifolioNewsResponse>) => {
    return useQuery<IFeedWikifolioNewsResponse>({
        url: API_FEED_V3_NEWS_WIKIFOLIO,
        queryKey: feedKeys.news.wikifolio(wikifolioId),
        queryParams: new URLSearchParams({ wikifolioId }),
        ...options,
    });
};
